<template>
	<div>
		<label>{{ $t('ordonnance.donner_un_nom') }}* :</label>
		<div class="form-group">
			<input type="text" class="form-control" v-model="document_name" :placeholder="$t('ordonnance.donner_un_nom')" required>
		</div>

		<label>{{ $t('ordonnance.document_date') }}* :</label>
		<div class="form-group">
			<e-datepicker v-model="document_date" required />
		</div>

        <label>{{ $t('ordonnance.choisir_acte') }} :</label>
		<div class="form-group">
            <e-select
                v-model="document_acte"
                id="actes_id"
                track-by="actes_id"
                label="inline_content"
                :placeholder="$t('notes.select_optionnal_act')"
                :selectedLabel="$t('global.selected_label')"
                :options="acts"
                :searchable="true"
                :allow-empty="true"
                :loading="loading_acts"
                :sortable="false"
			/>
		</div>

        <label>{{ $t('ordonnance.choisir_document') }}</label>
        <div>
            <b-form-file
                    v-model="document_file"
                    :placeholder="$t('media.choisir_document')"
                    :drop-placeholder="$t('fichier.drop_file')+'...'"
            ></b-form-file>
            <div v-show="(document_file && isValidSizeFile) || document_filename" class="mt-3">{{ $t('fichier.selected_file') }}: {{ document_file ? document_file.name : document_filename }}</div>
		</div>

		<ButtonValidation @btn-onclick="valid_form" icon="suivant" />
	</div>
</template>

<script type="text/javascript">
    import Documents from "@/mixins/Documents.js"
    import Shutter from '@/mixins/Shutter.js'
    import ActesMixin from "@/mixins/Actes.js"

    export default {
        name: "OrdonnanceEdit",
        mixins: [Documents, Shutter, ActesMixin],
        props: [
            'document_id',
            'horse_id',
            'from',
            'acte_id'
        ],
        components: {
            ButtonValidation: () => import('GroomyRoot/components/Buttons/Validation')
        },
        data () {
            return {
                document_limit_size: '10', // Mo
                document_file: null,
                document_filename: null,
                document_name: '',
                document_date: null,
                document_acte: null,
                actual_date: new Date(),
                acts: [],
                loading_acts: false,
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            async init_component() {
                this.document = await this.loadDocument(this.document_id)
                this.document_date = Date.parseTz(this.document.document_date)
                this.document_name = this.document.document_name
                this.document_filename = this.document.document_filename

                if(this.horse_id) {
					this.loading_acts = true
					await this.getLastHorseActs(this.horse_id)
						.then(res => {
                            this.acts = res
                            if(this.acte_id) {
                                this.document_acte = this.acts.find(acte => acte.actes_id == this.acte_id)
                            }
                        })
						.finally(() => this.loading_acts = false)
				}
            },

            async valid_form() {
                let params = {
                    document_name: this.document_name,
                    document_date: Date.parseTz(this.document_date),
                }
                if(this.document_file) {
                    const filename = await this.$sync.uploadFile(this.document_file)
                     params = {
                        document_name: this.document_name,
                        document_date: Date.parseTz(this.document_date),
                        document_filename: filename
                    }
                }
				await this.updateDocument(params, this.document_id)
                await this.updateDocumentActeLien(this.document_id, this.document_acte)
				this.successToast()
				this.ok()
            }
        },
        computed: {
 			isValidSizeFile() {
                const file_size = this.document_file.size         // Taille en octets
                const limit = this.document_limit_size * 1000000  // conversion en octets
                return file_size < limit
            }
		},
    }
</script>
